import { 
  doc, 
  setDoc, 
  getDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION_NAME = 'users';

export const userService = {
  // Save or update user in Firestore
  async saveUser(userData) {
    try {
      const userRef = doc(db, COLLECTION_NAME, userData.uid);
      
      // Check if user already exists
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        // Update existing user
        await setDoc(userRef, {
          ...userSnap.data(),
          email: userData.email,
          displayName: userData.displayName,
          photoURL: userData.photoURL,
          lastLoginAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        }, { merge: true });
        
        return { ...userSnap.data(), isNewUser: false };
      } else {
        // Create new user
        const newUserData = {
          ...userData,
          hasSeenTutorial: false, // Track tutorial status
          createdAt: serverTimestamp(),
          lastLoginAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        };
        
        await setDoc(userRef, newUserData);
        return { ...newUserData, isNewUser: true };
      }
    } catch (error) {
      console.error('Error saving user:', error);
      throw error;
    }
  },

  // Mark tutorial as seen
  async markTutorialSeen(uid) {
    try {
      const userRef = doc(db, COLLECTION_NAME, uid);
      await setDoc(userRef, {
        hasSeenTutorial: true,
        updatedAt: serverTimestamp()
      }, { merge: true });
    } catch (error) {
      console.error('Error marking tutorial as seen:', error);
      throw error;
    }
  },

  // Get user data
  async getUser(uid) {
    try {
      const userRef = doc(db, COLLECTION_NAME, uid);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        return { id: userSnap.id, ...userSnap.data() };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting user:', error);
      throw error;
    }
  }
};
